export default __webpack_public_path__ + "static/media/D-DIN-Bold.7bb4b1a4.otf";